export var USER_DATA_CHANGED='USER_DATA_CHANGED';/* export function changeUserLoggedIn() {
  return {
    type: HAS_USER_LOGGED_IN,
  };
} */export default function changeUserData(payload){return{type:USER_DATA_CHANGED,payload:payload};}